module.exports = __webpack_public_path__ + "static/media/dashboard-color.9541089d.svg";